// ==============================
// BACK TO TOP
// ==============================
document.addEventListener("DOMContentLoaded", function () {

    const button = document.getElementById("backToTop");

    if(!button) return;

    window.addEventListener("scroll", function(){

        if(window.scrollY > 400){
            button.classList.add("is-visible");
        } else {
            button.classList.remove("is-visible");
        }

    });

    button.addEventListener("click", function(){

        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

    });

});


// ==============================
// FLYOUT MENU
// ==============================
document.addEventListener("DOMContentLoaded", function () {

  const flyout = document.querySelector(".ww-flyout");

  // Das Flyout ist abschaltbar (flyoutmenu.enabled in theme-settings.php).
  // Ohne das Element gibt es nichts zu beobachten - und keinen Grund,
  // einen globalen Scroll-Listener zu registrieren.
  if (!flyout) return;

  // Ab hier steuert JavaScript die Sichtbarkeit. Ohne diese Klasse bleibt
  // der Schnellzugriff dauerhaft sichtbar und bedienbar - vorher stand im
  // CSS opacity:0 ohne Gegenstueck, ohne JS war die Komponente also nie
  // zu sehen. Die Klasse blendet ausserdem die Back-to-Top-Schaltflaeche
  // ein, die ohne JavaScript nichts tut.
  flyout.classList.add("is-scroll-managed");

  const scrollTopBtn = flyout.querySelector(".ww-scroll-top");

  // Sichtbarkeit nach 200px Scroll
  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      flyout.classList.add("is-visible");
    } else {
      flyout.classList.remove("is-visible");
    }
  });

  // Smooth Scroll to Top
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

});